import { render, staticRenderFns } from "./batchArriveFill.vue?vue&type=template&id=705646f4&scoped=true"
import script from "./batchArriveFill.vue?vue&type=script&lang=js"
export * from "./batchArriveFill.vue?vue&type=script&lang=js"
import style0 from "./batchArriveFill.vue?vue&type=style&index=0&id=705646f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705646f4",
  null
  
)

export default component.exports